import { Box, Stack, Text } from '@mantine/core';
import useAiAnalystContext from '@providers/AiAnalyst/useAiAnalystContext';
import SuggestedActions from '../SuggestedActions';

interface EmptyChatBodyProps {
    title?: string;
    description?: string;
    showSuggestions?: boolean;
}

const EmptyChatBody: React.FC<EmptyChatBodyProps> = ({
    title = 'Hey Advait!',
    description = 'What do you want to know about your supply chain today?',
    showSuggestions = true,
}) => {
    const { aiChatMessages } = useAiAnalystContext((context) => context.state);

    if (aiChatMessages.length) return null;

    return (
        <Stack className={`h-full w-full flex-1 justify-end gap-0`}>
            {title && (
                <Stack className={`mb-5 w-full items-start gap-0`}>
                    <Text className={`text-lg font-semibold text-gray-800`}>
                        {title}
                    </Text>
                    {description && (
                        <Text className={`text-sm font-medium text-gray-600`}>
                            {description}
                        </Text>
                    )}
                </Stack>
            )}

            <Box className="mt-4 w-full">
                {showSuggestions && <SuggestedActions />}
            </Box>
        </Stack>
    );
};

export default EmptyChatBody;
